import _ from 'underscore';
import { ApiLegLink } from '@ve/types/api/ApiLegLink';

import { RailwayTariff, Station } from '@ve/types';
import { ApiRailwayLeg } from '@ve/types/railway/ApiRailwayLeg';

import { RailwayLegInfo } from './types';

type LegKeys = {
    [key: string]: ApiRailwayLeg;
};

type TariffKeys = {
    [key: string]: RailwayTariff;
};

type StationsKeys = {
    [key: string]: Station;
};

export default ({
                    legs,
                    legKeys,
                    tariffKeys,
                    stationKeys,
                }:
                    {
                        legs: ApiLegLink[];
                        legKeys: LegKeys;
                        tariffKeys: TariffKeys;
                        stationKeys: StationsKeys
                    }): RailwayLegInfo[][] => _.map(legs, (leg) => {
    const apiLegInfo = legKeys[leg.id];

    const legInfo = {
        ..._.pick(apiLegInfo, 'arrivalDate', 'carrier', 'departureDate', 'tripTime', 'train'),
        id: leg.id,
        legId: leg.id,
        type: 'train',
        transfer: leg.transfer,
        stationArrival: stationKeys[apiLegInfo.stationArrival],
        stationDeparture: stationKeys[apiLegInfo.stationDeparture],
    };
    return leg.tariffs.map((tariff) => {
        const tariffInfo = tariffKeys[tariff.id];
        return {
            id: `${apiLegInfo.id}~${tariff.id}`,
            additionalTax: tariff.price,
            leg: {
                ...legInfo,
                tariffId: tariff.id,
                carType: tariffInfo.carType,
            },
        };
    });
});